import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaStar } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import google from "../../assets/images/google.webp";
import testimonialImg1 from "../../assets/images/testimonials/user.webp";
import slide6 from "../../assets/images/testimonials/slide6.webp";
import khushi from "../../assets/images/testimonials/khushi.webp";
import sheetal from "../../assets/images/testimonials/sheetal.webp";
import moveon from "../../assets/images/testimonials/moveon.webp";
import akash from "../../assets/images/testimonials/akash.webp";
import vijaysingh from "../../assets/images/testimonials/vijaysingh.webp";

const options = {
    margin: 30,
    responsiveClass: true,
    nav: true,
    autoplay: true,
    autoplayTimeout: 3000,
    navText: ["<", ">"],
    smartSpeed: 1000,
    loop: true,
    responsive: {
        0: {
            items: 1,
        },
        400: {
            items: 1,
        },
        600: {
            items: 2,
        },
        700: {
            items: 2,
        },
        1000: {
            items: 3,
        },
    },
};

function HomeGoogleReviews() {
    return (
        <section className="testimonials__wrapper silder__wrapper pb-5">
            <Container>
                <Row>
                    <Col>
                        <div className="title__wrap regular">
                            <h2 className="primary-color">Google Reviews</h2>
                        </div>
                    </Col>
                    <Col className="text-end">
                        <div className="rating">
                            <picture>
                                <source srcSet={google} type="image/webp" />
                                <img src={google} alt="" />
                            </picture>
                            <span>
                                Google <strong> 4.9</strong>
                            </span>
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className="review_wrapper mt-4">
                            <Row className="align-items-center">
                                <Col md={6} xs={6}>
                                    <h4 className="fw-bold">Rating</h4>
                                    <div className="d-block d-md-flex gap-3 align-items-end">
                                        <p className="m-0 d-flex gap-2">
                                            <span>4.9</span>
                                            <span>
                                                <FaStar />
                                                <FaStar />
                                                <FaStar />
                                                <FaStar />
                                                <FaStar />
                                            </span>
                                        </p>
                                        <div className="rate">22 Reviews</div>
                                    </div>
                                </Col>
                                <Col md={6} xs={6} className="text-end">
                                    <Link
                                        to="https://g.page/r/CTxW-jOLnvyhEBM/review"
                                        target="_blank"
                                        className="readmore__btn m-0"
                                    >
                                        Write a review
                                    </Link>
                                </Col>
                            </Row>
                        </div>
                    </Col>

                    <Col md={12} className="text-end mt-4">
                        {/* <div className="google_reviews">
                <strong>Google Rating</strong>
                <span>
                  4.9 <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                </span>
              </div> */}
                        <Row>
                            <Col xs={9} md={11} className="m-auto">
                                <OwlCarousel
                                    className="slider-items owl-carousel"
                                    {...options}
                                >
                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>
                                                    “Pure IONIA is a great company that cares about the
                                                    environment, and the quality of water that they
                                                    serve is impeccable! The customer service is very
                                                    welcoming and friendly. Would definitely recommend
                                                    to anyone who is interested in drinking completely
                                                    ionized water with alkaline minerals added for that
                                                    extra health boost!”
                                                </p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={testimonialImg1}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Mukul Sohlot</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>
                                                    " Best water alkaline machine in India. We are using
                                                    it from last one year and got amazing health
                                                    results."
                                                </p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={slide6}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Neha Rajput</h3>
                                                    <p>6 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>
                                                    "Pure Ionia is best alkaline machine in budget. My
                                                    acidity and constipation problem is solved after 5
                                                    month of using alkaline water"
                                                </p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={testimonialImg1}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Ashok Jain</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>
                                                    "Very happy of using this Ionizer as my thyroid
                                                    level has also got cured with in last two months
                                                    .Thanks to you guys."
                                                </p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={testimonialImg1}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Nimit Creators</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>"Nice product.. experience is very good."</p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={sheetal}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Sheetal Mittal</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>
                                                    "2 years ago Excellent product in budget much lower
                                                    than competitor' s brand almost half rate with same
                                                    quality, value for money and health. Using since
                                                    last 5 months my family feel energetic and my
                                                    stomach acidity problem is gone."
                                                </p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={vijaysingh}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Vijay Singh Yadav</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>"Good machine for alkaline water."</p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={khushi}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Khushi Rajput</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>"Best Alkaline Water Ionizer."</p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={testimonialImg1}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Bhopendra Panwar</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>Quick setup and the water is clear and clean.</p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={akash}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />
                                                <div className="info">
                                                    <h3>Aakash Kumar Singh</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="item">
                                        <div className="review_box">
                                            <div className="comment">
                                                <div className="ratings">
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                    <FaStar />
                                                </div>
                                                <p>One of the best product.</p>
                                            </div>
                                            <div className="bottom_info">
                                                <img
                                                    src={moveon}
                                                    width="100%"
                                                    alt=""
                                                    className="thumb"
                                                />

                                                <div className="info">
                                                    <h3>MOVE ON - LIFE</h3>
                                                    <p>5 Months ago</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </OwlCarousel>
                            </Col>
                        </Row>
                        {/* <div class="elfsight-app-a1d68ca4-a5ce-4355-9f96-2497e1213def"></div> */}
                        {/* <GoogleReviews /> */}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default HomeGoogleReviews